export const appBaseURL = "/"

export const appPageTransition = {"name":"page","mode":"out-in","css":false}

export const appLayoutTransition = {"name":"layout","mode":"out-in"}

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover"},{"name":"format-detection","content":"telephone=no"},{"name":"description","content":"腾达（Tenda）官方网站和在线商城，提供 WiFi 路由器、交换机、网络摄像机等全系列网络设备与解决方案。"},{"name":"referrer","content":"strict-origin-when-cross-origin"},{"http-equiv":"x-dns-prefetch-control","content":"on"},{"name":"theme-color","content":"#fb5100"},{"name":"robots","content":"index,follow"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"preconnect","href":"https://mall.tenda.com.cn/tdc/api"},{"rel":"dns-prefetch","href":"https://mall.tenda.com.cn/tdc/api"},{"rel":"preconnect","href":"https://ip-com-app.oss-cn-shenzhen.aliyuncs.com","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://ip-com-app.oss-cn-shenzhen.aliyuncs.com"}],"style":[],"script":[],"noscript":[],"title":"腾达(Tenda) 官方网站"}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true